import { SvgWrapper } from "./SvgWrapper";
import { BaseIcon } from "./types";

export const MdiRule = (props: BaseIcon) => (
  <SvgWrapper {...props}>
    <path d="M9.59967 13.3334L8.66634 12.4L10.3997 10.6667L8.66634 8.93337L9.59967 8.00003L11.333 9.73337L13.0663 8.00003L13.9997 8.93337L12.2663 10.6667L13.9997 12.4L13.0663 13.3334L11.333 11.6L9.59967 13.3334ZM10.9163 7.33337L8.54967 4.9667L9.48301 4.03337L10.8997 5.45003L13.733 2.6167L14.6663 3.5667L10.9163 7.33337ZM1.33301 11.3334V10H7.33301V11.3334H1.33301ZM1.33301 6.00003V4.6667H7.33301V6.00003H1.33301Z"/>
  </SvgWrapper>
)
